import * as React from 'react'
import * as _ from 'lodash'
import './Scratch.css'

import Block from "./Block"
import Steps from "./Steps"

import { newId } from '../lib/id'
// import { evaluateSteps, runCodeToResult } from '../evaluate'
import * as actions from '../actions'
import { standardSCU, arrRemove } from '../util'
import { NetworkUser } from 'golgi'
import { Cursor, CursorV } from '../lib/Cursor'
import { Stack } from '../types/stack';

import * as Model from '../types/document'
import { runCodeToResult } from 'src/model/run';

interface ScratchProps {
  blockC: Cursor<Model.Block>,
  stack: Stack,
}

class Scratch extends React.Component<ScratchProps> {
  render() {
    return <NetworkUser debugName="Scratch" props={this.props} state={this.state} render={() => {
      const {blockC, stack} = this.props

      return (
        <Block
          className="Scratch"
          left={
            <div className="Scratch-heading" style={{height: 40, fontSize: "200%"}}>
              scratch
            </div>
          }
          right={
            <Steps stepsC={blockC.select('steps')} blockC={blockC} stack={stack}/>
          }
        />
      )
    }} />
  }
}

export default Scratch;



// WEBPACK FOOTER //
// ./src/view/Scratch.tsx